// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Textarea_inputError__CG520 {
    outline: 2.5px solid var(--color-red-dark-1);
    outline-offset: -1.5px;
}

.Textarea_textarea__9lOES {
    border: 1.5px solid var(--color-lightui-surface-4);
    min-height: 70px;
    height: 70px;
    width: 100%;
    vertical-align: top;
    box-shadow: none;
    padding: 4px 6px;
    border-radius: 4px;
    box-sizing: border-box;
    resize: none;
    font-size: 14px;
}

.Textarea_textarea__9lOES:not(.Textarea_disabled__f0FZV):hover {
    outline: 1.5px solid var(--color-lightui-accent-2);
    outline-offset: -1.5px;
}

.Textarea_textarea__9lOES.Textarea_disabled__f0FZV {
    background-color: var(--color-lightui-surface-2);
}

.Textarea_textarea__9lOES:focus,
.Textarea_textarea__9lOES:focus:hover {
    outline: 2.5px solid var(--color-primary);
    outline-offset: -1.5px;
}

.Textarea_label__xWPng {
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-size: 14px;
    line-height: 21px;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
}

.Textarea_label__xWPng:hover {
    cursor: default;
}

.Textarea_helperText__wLIpX {
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    margin-top: 4px;
    color: var(--color-darkui-accent-2);
}

.Textarea_validationError__UH3fw {
    display: flex;
    align-items: center;
    margin-top: 4px;
}

.Textarea_validationErrorIcon__MeWUr {
    color: var(--color-red-dark-1);
}

.Textarea_validationErrorText__kLQX2 {
    margin-left: 4px;
    color: var(--color-red-dark-1);
    height: 18px;
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
}

.Textarea_lowerTextContainer__vX9Eo {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.Textarea_counter__5ElIx {
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: var(--color-darkui-accent-2);
    margin-top: 4px;
    margin-left: 8px;
}

/* --- Story Styles --- */

.Textarea_formButton__jI5H3 {
    color: white;
    border-radius: 4px;
    padding: 4px 8px 4px 8px;
    background: var(--color-primary);
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Textarea/Textarea.module.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,sBAAsB;AAC1B;;AAEA;IACI,kDAAkD;IAClD,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kDAAkD;IAClD,sBAAsB;AAC1B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;;IAEI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,uHAAuH;IACvH,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uHAAuH;IACvH,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,YAAY;IACZ,uHAAuH;IACvH,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,uHAAuH;IACvH,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mCAAmC;IACnC,eAAe;IACf,gBAAgB;AACpB;;AAEA,yBAAyB;;AAEzB;IACI,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,eAAe;AACnB","sourcesContent":[".inputError {\n    outline: 2.5px solid var(--color-red-dark-1);\n    outline-offset: -1.5px;\n}\n\n.textarea {\n    border: 1.5px solid var(--color-lightui-surface-4);\n    min-height: 70px;\n    height: 70px;\n    width: 100%;\n    vertical-align: top;\n    box-shadow: none;\n    padding: 4px 6px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    resize: none;\n    font-size: 14px;\n}\n\n.textarea:not(.disabled):hover {\n    outline: 1.5px solid var(--color-lightui-accent-2);\n    outline-offset: -1.5px;\n}\n\n.textarea.disabled {\n    background-color: var(--color-lightui-surface-2);\n}\n\n.textarea:focus,\n.textarea:focus:hover {\n    outline: 2.5px solid var(--color-primary);\n    outline-offset: -1.5px;\n}\n\n.label {\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-size: 14px;\n    line-height: 21px;\n    display: flex;\n    align-items: center;\n    margin-bottom: 4px;\n}\n\n.label:hover {\n    cursor: default;\n}\n\n.helperText {\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    margin-top: 4px;\n    color: var(--color-darkui-accent-2);\n}\n\n.validationError {\n    display: flex;\n    align-items: center;\n    margin-top: 4px;\n}\n\n.validationErrorIcon {\n    color: var(--color-red-dark-1);\n}\n\n.validationErrorText {\n    margin-left: 4px;\n    color: var(--color-red-dark-1);\n    height: 18px;\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n}\n\n.lowerTextContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.counter {\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    color: var(--color-darkui-accent-2);\n    margin-top: 4px;\n    margin-left: 8px;\n}\n\n/* --- Story Styles --- */\n\n.formButton {\n    color: white;\n    border-radius: 4px;\n    padding: 4px 8px 4px 8px;\n    background: var(--color-primary);\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputError": `Textarea_inputError__CG520`,
	"textarea": `Textarea_textarea__9lOES`,
	"disabled": `Textarea_disabled__f0FZV`,
	"label": `Textarea_label__xWPng`,
	"helperText": `Textarea_helperText__wLIpX`,
	"validationError": `Textarea_validationError__UH3fw`,
	"validationErrorIcon": `Textarea_validationErrorIcon__MeWUr`,
	"validationErrorText": `Textarea_validationErrorText__kLQX2`,
	"lowerTextContainer": `Textarea_lowerTextContainer__vX9Eo`,
	"counter": `Textarea_counter__5ElIx`,
	"formButton": `Textarea_formButton__jI5H3`
};
export default ___CSS_LOADER_EXPORT___;
